import React from 'react';
import { Button, Select, Typography, Radio } from 'antd';
import { SearchBar } from '../SearchBar/SearchBar';
import './SearchFiltersSection.scss';

const { Option } = Select;

// Define a type for the filter keys
type FilterKey = "selectedMakes" | "selectedModels" | "websites" | "reserveStatus" | "sellerType" | "pastToggle";

interface SearchFiltersSectionProps {
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  filterValues: any;
  handleFilterChange: (filterKey: FilterKey, values: string[]) => void;
  handleSearch: () => void;
  makes: string[];
  models: string[];
  websites: string[];
  showModal: () => void;
  isClassifieds: boolean;
  setIsClassifieds: (value: boolean) => void;
  resetFilters: () => void;
}

const SearchFiltersSection: React.FC<SearchFiltersSectionProps> = ({
  searchTerm,
  onSearchTermChange,
  filterValues,
  handleFilterChange,
  handleSearch,
  makes,
  models,
  websites,
  showModal,
  isClassifieds,
  setIsClassifieds,
  resetFilters
}) => {
  return (
    <>
      <div className="learn-more-banner">
        <Typography.Link onClick={showModal}>
          Learn more about Scout
        </Typography.Link>
      </div>
      <div className="search-bar-wrapper">
        <div className="search-bar-container">
          <SearchBar onSearchTermChange={onSearchTermChange} />
        </div>
        <Button
          type="primary"
          className="search-button"
          onClick={handleSearch}
        >
          Search
        </Button>
      </div>

      <div className="filters-wrapper">
        <Radio.Group
          value={isClassifieds ? "classifieds" : "auctions"}
          onChange={(e) => {
            setIsClassifieds(e.target.value === "classifieds");
            resetFilters();
          }}
          buttonStyle="solid"
          style={{ marginRight: "10px", whiteSpace: "nowrap" }}
        >
          <Radio.Button value="auctions">Auctions</Radio.Button>
          <Radio.Button value="classifieds">Classifieds</Radio.Button>
        </Radio.Group>
        <Select
          mode="multiple"
          placeholder="Make"
          style={{ width: "200px", marginRight: "10px" }}
          onChange={(values) =>
            handleFilterChange("selectedMakes", values)
          }
          allowClear
          optionLabelProp="label"
          value={filterValues.selectedMakes}
        >
          {makes.map((make) => (
            <Option key={make} value={make} label={make}>
              {make}
            </Option>
          ))}
        </Select>
        <Select
          mode="multiple"
          placeholder="Model"
          style={{ width: "200px", marginRight: "10px" }}
          onChange={(values) =>
            handleFilterChange("selectedModels", values)
          }
          allowClear
          optionLabelProp="label"
          value={filterValues.selectedModels}
          notFoundContent={
            filterValues.selectedMakes.length === 0
              ? "Please select a make first"
              : "No models found"
          }
        >
          {models.map((model) => (
            <Option key={model} value={model} label={model}>
              {model}
            </Option>
          ))}
        </Select>

        <Select
          mode="multiple"
          placeholder="Website"
          style={{ width: "200px", marginRight: "10px" }}
          onChange={(values) => handleFilterChange("websites", values)}
          allowClear
          optionLabelProp="label"
          value={filterValues.websites}
        >
          {websites.map((website) => (
            <Option key={website} value={website} label={website}>
              {website}
            </Option>
          ))}
        </Select>
        {!isClassifieds && (
          <>
            <Select
              mode="multiple"
              placeholder="Reserve Status"
              style={{ width: "200px", marginRight: "10px" }}
              onChange={(values) =>
                handleFilterChange("reserveStatus", values)
              }
              allowClear
              optionLabelProp="label"
              value={filterValues.reserveStatus}
            >
              <Option value="Reserve" label="Reserve">
                Reserve
              </Option>
              <Option value="No Reserve" label="No Reserve">
                No Reserve
              </Option>
            </Select>
            <Select
              mode="multiple"
              placeholder="Seller Type"
              style={{ width: "200px", marginRight: "10px" }}
              onChange={(values) => handleFilterChange("sellerType", values)}
              allowClear
              optionLabelProp="label"
              value={filterValues.sellerType}
            >
              <Option value="Dealer" label="Dealer">
                Dealer
              </Option>
              <Option value="Private" label="Private">
                Private
              </Option>
            </Select>
          </>
        )}
      </div>
    </>
  );
};

export default SearchFiltersSection;
